import { Button, FlexWrapper, HeroBlock, FontIcon, Notifications, MovieDetails, Text } from '@intigral/shared';
import withResposiveStyle from '@intigral/shared/components/hocs/ResponiseStyles/withResponsiveStyles';
import { MovieButtons } from '@intigral/ui';
import useShowPPvCta from '../../../hooks/useShowPPvCta';
import AddReminderButton from '../../../components/elements/AddReminderButton';
import { CountDownTimer } from '@intigral/shared/components/CountDownTimer';
import { __ } from '../../../translations';
import moment from 'moment';
import useLanguage from '../../../hooks/useLanguage';
import h from '../../../helpers/common';
import { PPVDetailContentProps } from '../types/iPPVEvents';

export const PPVDetailContent: React.FC<PPVDetailContentProps> = ({
    selectedPPVEvent,
    selectedChannel,
    selectedProgram,
    ppvSubscribedList,
    handleClickPurchase,
    handleClickPlay,
}) => {
    const language = useLanguage();
    const { isShowBuyNowCta, isShowReminderCta, isSubscribed, isRewind, isStreamingNow, isAvailableSoonCta } =
        useShowPPvCta(selectedPPVEvent, ppvSubscribedList);
    const { isLive, isCompleted, rewindDays } = selectedPPVEvent || {};

    const MButtons = withResposiveStyle(MovieButtons);
    const MBDetails = withResposiveStyle(MovieDetails);
    const heroImage = selectedPPVEvent?.eventData?.image || selectedProgram?.image_landscape || selectedProgram?.image;

    return (
        <FlexWrapper flexDirection="column" gap="2x">
            <HeroBlock heading={selectedPPVEvent?.name} picture={heroImage} compact detail></HeroBlock>
            <FlexWrapper
                flexDirection="column"
                gap="2x"
                paddingTop={{ default: '1x', md: '2x' }}
                paddingBottom={{ default: '1x', md: '2x' }}
            >
                <FlexWrapper
                    direction={{ default: 'column', md: 'row' }}
                    gap={{ default: '2x', md: '0' }}
                    justifyContent="between"
                >
                    <Notifications />
                    <MButtons
                        className="details"
                        paddingBottom={{ md: '3x' }}
                        {...(() => {
                            if (isShowBuyNowCta) {
                                return {
                                    play: (
                                        <Button onClick={handleClickPurchase}>
                                            <span>{__('ppv_addon_buy_now')}</span>{' '}
                                        </Button>
                                    ),
                                };
                            }
                            if (isAvailableSoonCta && !isRewind) {
                                return {
                                    play: (
                                        <Button secondary onClick={handleClickPlay}>
                                            <span>{__('available_soon')}</span>{' '}
                                        </Button>
                                    ),
                                };
                            }
                            if (isStreamingNow && isSubscribed && !isRewind) {
                                return {
                                    play: (
                                        <Button onClick={handleClickPlay}>
                                            <span>{__('watch_now')}</span>{' '}
                                        </Button>
                                    ),
                                };
                            }
                            if (isRewind && isSubscribed && !isStreamingNow) {
                                return {
                                    play: (
                                        <Button onClick={handleClickPlay}>
                                            <span>{__('ppv_replay')}</span>{' '}
                                        </Button>
                                    ),
                                };
                            }
                            return {};
                        })()}
                        reminderButton={
                            isShowReminderCta && (
                                <AddReminderButton
                                    item={selectedProgram}
                                    category="PPV"
                                    isComingSoon={true}
                                    secondary={true}
                                />
                            )
                        }
                    />
                    <div>
                        {!isLive && !isCompleted && (
                            <CountDownTimer
                                timeStamp={selectedPPVEvent?.eventBroadcastTs}
                                labelDay={__('timer_days')}
                                labelHour={__('timer_hours')}
                                labelMinute={__('timer_mins')}
                                labelSecond={__('timer_sec')}
                            />
                        )}
                    </div>
                </FlexWrapper>
                <MBDetails
                    paddingBottom={{ md: '3x' }}
                    info={[
                        moment(selectedPPVEvent?.eventBroadcastTs).format('MMMM D, YYYY'),
                        moment(selectedPPVEvent?.eventBroadcastTs).format('h:mm A'),
                    ]}
                    provider={[selectedChannel?.channelLogoSrc]}
                    rating={
                        selectedProgram?.ratings.length
                            ? __(`rating_${h.getGenreRating(selectedProgram?.ratings).toLowerCase()}`)
                            : null
                    }
                    dolby
                    quality4K
                />
                <div>
                    {isSubscribed && rewindDays && (
                        <Text as="span" color={rewindDays > 2 ? 'green' : 'red'}>
                            {__('ppv_content_available')} {rewindDays} {__(rewindDays > 1 ? 'ppv_days' : 'ppv_day')}
                        </Text>
                    )}
                </div>

                <Text as="p" alignment="start" margin="4x" style={{ opacity: 0.9 }}>
                    {language == 'en' ? selectedProgram?.description : selectedProgram?.descriptionLocalized?.ar}
                </Text>
            </FlexWrapper>
        </FlexWrapper>
    );
};
